import React, { useMemo } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { useParams, matchPath, Link } from 'react-router-dom';

function activeTab(pathname, basePath) {
  if (matchPath(pathname, { path: `${basePath}/previews`, exact: true })) {
    return 'previews';
  }
  if (matchPath(pathname, { path: `${basePath}/settings`, exact: true })) {
    return 'settings';
  }
  if (matchPath(pathname, { path: `${basePath}/weights`, exact: true })) {
    return 'weights';
  }
  return 'configuration';
}

/**
 * Tab navigation for workspace rubric routes (configuration, weights, preview, settings).
 */
function RubricTabs() {
  const { workspaceId, rubricId } = useParams();
  const basePath = `/w/${workspaceId}/rubrics/${encodeURIComponent(rubricId)}`;
  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : '';

  const tab = useMemo(
    () => activeTab(pathname, basePath),
    [pathname, basePath]
  );

  return (
    <Nav className="tab-nav nav-underline">
      <NavItem>
        <NavLink
          tag={Link}
          active={tab === 'configuration'}
          data-view="configuration"
          to={basePath}
        >
          Configuration
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          tag={Link}
          active={tab === 'weights'}
          data-view="weights"
          to={`${basePath}/weights`}
        >
          Weights
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          tag={Link}
          active={tab === 'previews'}
          data-view="previews"
          to={`${basePath}/previews`}
        >
          Preview
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          tag={Link}
          active={tab === 'settings'}
          data-view="settings"
          to={`${basePath}/settings`}
        >
          Settings
        </NavLink>
      </NavItem>
    </Nav>
  );
}

export default RubricTabs;
